import { render, staticRenderFns } from "./MoverAcciones.vue?vue&type=template&id=531f7b24&"
import script from "./MoverAcciones.vue?vue&type=script&lang=js&"
export * from "./MoverAcciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports